import _defineProperty from "/home/runner/work/mono-marketplace-hub-ui/mono-marketplace-hub-ui/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import * as React from 'react';
import classNames from 'classnames';
import Conditional from '../misc/Conditional/index.js';
import CpLogo from './subcomponents/CpLogo.js';
import HamburgerButton from './subcomponents/HamburgerButton.js';
import LoggedOutNavigation from './subcomponents/LoggedOutNavigation.js';
import LoggedInNavigation from './subcomponents/LoggedInNavigation.js';
import Notifications from './subcomponents/Notifications.js';
import GoBack from './subcomponents/GoBack.js';
import useHeaderCP from './hook.js';
var HeaderCP = function HeaderCP(_ref) {
  var _ref$isLogged = _ref.isLogged,
    isLogged = _ref$isLogged === void 0 ? false : _ref$isLogged,
    mapLoggedOutMenuItems = _ref.mapLoggedOutMenuItems,
    customLogoLinks = _ref.customLogoLinks,
    _ref$showGoBack = _ref.showGoBack,
    showGoBack = _ref$showGoBack === void 0 ? false : _ref$showGoBack,
    onGoBackClick = _ref.onGoBackClick,
    showNotifications = _ref.showNotifications,
    notificationsNumber = _ref.notificationsNumber,
    onNotificationClick = _ref.onNotificationClick,
    _ref$username = _ref.username,
    username = _ref$username === void 0 ? "username" : _ref$username,
    whiteVersion = _ref.whiteVersion,
    customLoggedInMenuItems = _ref.customLoggedInMenuItems,
    mapLoggedInMenuItems = _ref.mapLoggedInMenuItems,
    customClass = _ref.customClass,
    loginLink = _ref.loginLink,
    profileLinkFunction = _ref.profileLinkFunction;
  var _useHeaderCP = useHeaderCP({
      mapLoggedOutMenuItems: mapLoggedOutMenuItems,
      username: username,
      mapLoggedInMenuItems: mapLoggedInMenuItems,
      customLoggedInMenuItems: customLoggedInMenuItems
    }),
    isMobileMenuOpen = _useHeaderCP.isMobileMenuOpen,
    toggleMobileMenu = _useHeaderCP.toggleMobileMenu,
    loggedoutNavigationLinks = _useHeaderCP.loggedoutNavigationLinks,
    loggedNavigationLinks = _useHeaderCP.loggedNavigationLinks,
    isSubmenuOpen = _useHeaderCP.isSubmenuOpen,
    formattedUsername = _useHeaderCP.formattedUsername;
  var headerClass = classNames("header-cp", _defineProperty({
    "header-cp--logged": isLogged,
    "header-cp--menu-mobile-open": isMobileMenuOpen,
    "header-cp--submenu-open": isSubmenuOpen,
    "header-cp--white-version": isLogged && whiteVersion
  }, "".concat(customClass), !!customClass));
  return /* @__PURE__ */React.createElement("header", {
    className: headerClass
  }, /* @__PURE__ */React.createElement("nav", {
    className: "header-cp__navbar",
    "aria-label": "Navega\xE7\xE3o cabe\xE7alho"
  }, /* @__PURE__ */React.createElement("div", {
    className: "header-cp__container"
  }, /* @__PURE__ */React.createElement("div", {
    className: "header-cp__panel-left"
  }, /* @__PURE__ */React.createElement(Conditional, {
    condition: isLogged && showGoBack,
    renderIf: /* @__PURE__ */React.createElement(GoBack, {
      onGoBackClick: onGoBackClick
    })
  }), /* @__PURE__ */React.createElement(CpLogo, {
    isLogged: isLogged,
    customLinks: customLogoLinks
  })), /* @__PURE__ */React.createElement("div", {
    className: "header-cp__panel-right"
  }, /* @__PURE__ */React.createElement(Conditional, {
    condition: !!showNotifications && isLogged,
    renderIf: /* @__PURE__ */React.createElement(Notifications, {
      count: notificationsNumber,
      onNotificationClick: onNotificationClick
    })
  }), /* @__PURE__ */React.createElement("div", {
    className: "header-cp__menu-holder"
  }, /* @__PURE__ */React.createElement(Conditional, {
    condition: isLogged,
    renderIf: /* @__PURE__ */React.createElement(LoggedInNavigation, {
      username: formattedUsername,
      loggedMenuLinks: loggedNavigationLinks,
      profileLinkFunction: profileLinkFunction
    }),
    renderElse: /* @__PURE__ */React.createElement(LoggedOutNavigation, {
      links: loggedoutNavigationLinks,
      loginLink: loginLink
    })
  })), /* @__PURE__ */React.createElement(HamburgerButton, {
    isOpen: isMobileMenuOpen,
    onToggleMenu: toggleMobileMenu
  })))));
};
export { HeaderCP as default };